import { Button, ModalV3, useTranslation } from '@helios/frontend-core';

import { PalmettoIcon } from '@palmetto/dsm-components';
import { PointOfContact } from '../../../api/project/types';

interface PocModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  pointOfContact: PointOfContact;
}

const PocModal = (props: PocModalProps) => {
  const { isOpen, onDismiss, pointOfContact } = props;
  const { t } = useTranslation();
  const TRACKING_ID = 'poc-modal';

  return (
    <ModalV3 open={isOpen} onClose={onDismiss} trackingId={TRACKING_ID}>
      <div className="flex flex-col gap-40">
        <div>
          <span className="body-400 text-text-tertiary">{t('pocModal.yourInstaller')}</span>
          <div className="mt-2 heading-400 text-text-primary">{pointOfContact.parentEntityName}</div>
          <a href={`tel:${pointOfContact.phone}`} className="mt-10 flex flex-row gap-6 items-center">
            <PalmettoIcon aria-hidden="true" name="phone" size="sm" className="text-icon-secondary shrink-0" />
            <span className="body-500 text-text-primary">{pointOfContact.phone}</span>
          </a>
        </div>
        <div>
          <Button
            as="a"
            href={`mailto:${pointOfContact.email}`}
            trackingId={`${TRACKING_ID}-send-email`}
            leadingIcon={<PalmettoIcon aria-hidden="true" name="mail" size="sm" />}
          >
            {t('pocModal.cta')}
          </Button>
        </div>
      </div>
    </ModalV3>
  );
};

export default PocModal;
